import { Caption } from '@liveauctioneers/hammer-ui-core/text';

import type { SimilarItemAlert } from '@/redux/modules/similarItemAlerts/similarItemAlerts.types';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { SimilarItemAlertRow } from './SimilarItemAlertRow';
import { SimilarItemAlertsTableRow } from './SimilarItemAlertsTableRow';

type Props = {
    alerts: SimilarItemAlert[];
};

export const SimilarItemAlertsTable = ({ alerts }: Props) => {
    const formatMessage = useAppFormatMessage();

    return (
        <>
            <SimilarItemAlertsTableRow
                dateAdded={
                    <Caption
                        className="uppercase"
                        color="secondary"
                    >
                        {formatMessage(['notificationsPage', 'table', 'header', 'dateAdded'])}
                    </Caption>
                }
                email={
                    <Caption
                        className="uppercase"
                        color="secondary"
                    >
                        {formatMessage(['notificationsPage', 'table', 'header', 'emailAlert'])}
                    </Caption>
                }
                item={
                    <Caption
                        className="uppercase"
                        color="secondary"
                    >
                        {formatMessage(['notificationsPage', 'table', 'header', 'item'])}
                    </Caption>
                }
                lastAlert={
                    <Caption
                        className="uppercase"
                        color="secondary"
                    >
                        {formatMessage(['notificationsPage', 'table', 'header', 'lastAlert'])}
                    </Caption>
                }
            />
            {alerts.map((alert) => (
                <SimilarItemAlertRow
                    alert={alert}
                    key={alert.savedItemId}
                />
            ))}
        </>
    );
};
